export const BATCH_ACTIONS = 'BATCH_ACTIONS';
export const AXIOS_TIMEOUT_ERROR_CODE = 'ECONNABORTED';
export const CAR_AND_DRIVER = {
  BOOKING_WIDGET: {
    POINT_TO_POINT: 'POINT_TO_POINT',
    BY_THE_HOUR: 'BY_THE_HOUR',
    DATE_TIME_FORMAT: 'YYYY-MM-DDTHH:mm'
  },
  TRAVELER_INFORMATION: {
    FIRST_NAME: 'first_name',
    LAST_NAME: 'last_name',
    DAY_PHONE: 'day_phone',
    CELL_PHONE: 'cell_phone',
    EVENING_PHONE: 'evening_phone',
    EMAIL_ADDRESS: 'email_address'
  }
};
export const CLEAN = {
  CLEAN_DATA_BY_STORE_KEY: 'CLEAN_DATA_BY_STORE_KEY',
  CLEAN_LOCATIONS_STATE: 'CLEAN_LOCATIONS_STATE',
  CLEAN_MESSAGES: 'CLEAN_MESSAGES',
  CLEAN_PROFILE_STATE: 'CLEAN_PROFILE_STATE',
  CLEAN_RESERVATION_STATE: 'CLEAN_RESERVATION_STATE',
  CLEAN_SOLR_STATE: 'CLEAN_SOLR_STATE'
};
export const FILTERS = {
  COMPOSE_FILTERS_UI_SHAPE: 'COMPOSE_FILTERS_UI_SHAPE',
  SET_FILTERS_UI_VALUES: 'SET_FILTERS_UI_VALUES',
  SET_NEXT_FILTERS_UI: 'SET_NEXT_FILTERS_UI,',
  TOGGLE_SEGMENTS_UI: 'TOGGLE_SEGMENTS_UI',
  // this const has nothing to do with the filters UI; its used to store filtered data in redux instead
  // of having to run a filter util every time the store updates
  SAVE_FILTERED_ARRAYS: 'SAVE_FILTERED_ARRAYS',
  SORT_FILTERED_UI_VALUES: 'SORT_FILTERED_UI_VALUES'
};
export const GMI = {
  DELETE_GMI_STATE: 'DELETE_GMI_STATE',
  SET_GMI_STATE: 'SET_GMI_STATE',
  UPDATE_GMI_STATE_LIST_BY_UID: 'UPDATE_GMI_STATE_LIST_BY_UID'
};
export const REQUEST = {
  CDA: 'CDA',
  GMA: 'GMA',
  SOLR: 'SOLR',
  REQUEST_START: 'REQUEST_START',
  REQUEST_ERROR: 'REQUEST_ERROR',
  REQUEST_SUCCESS: 'REQUEST_SUCCESS',
  REQUEST_COMPLETE: 'REQUEST_COMPLETE',
  UPDATE_SESSION: 'UPDATE_SESSION',
  SESSION_TIMED_OUT: 'SESSION_TIMED_OUT'
};
export const EXTERNAL_API = {
  GOOGLE_MAPS: 'https://maps.googleapis.com/maps/api/js'
};
export const DEEPLINK_QS = {
  IATA_NUMBER: 'iata_number',
  CASH_IN_CLUB_NUMBER: 'cash_in_club_number',
  RENTER_AGE: 'renter_age',
  REDEMPTION_DAY_COUNT: 'redemption_day_count',
  PARTNER_REWARD_PROGRAM_CODE: 'partner_reward_program_code',
  PARTNER_REWARD_PROGRAM_MEMBER_ID: 'partner_reward_program_member_id',
  STOP: 'stop',
  IGNORE_CONTRACT_FROM_PROFILE: 'ignore_contract_from_profile',
  SHOW_CASH_IN_CLUB_NUMBER: 'show_cash_in_club_number',
  SHOW_PRODUCT_CODE: 'show_product_code',
  PRODUCT_CODE: 'product_code',
  CAR_CLASS_CODE: 'car_class_code',

  BOOKING_AGENT: 'booking_agent',
  LAST_NAME: 'last_name',
  MEMBERSHIP_ID: 'membership_id',
  LOYALTY_BRAND: 'loyalty_brand',

  PICKUP_LOCATION_ID: 'pickup_location_id',
  RETURN_LOCATION_ID: 'return_location_id',
  PICKUP_DATE: 'pickup_date',
  PICKUP_TIME: 'pickup_time',
  RETURN_DATE: 'return_date',
  RETURN_TIME: 'return_time',
  CONTRACT_NUMBER: 'contract_number',
  COUPONS: 'coupons',
  ADDITIONALINFO: 'additionalInfo',
  ONE_WAY_RENTAL: 'one_way_rental',
  PREPAY_SELECTED: 'prepay_selected',
  LOCALE: 'locale',
  EXTRAS: 'extras',
  FIRSTNAME: 'firstname',
  EMAIL: 'email',
  PHONENUMB: 'phoneNumb',
  BILLINGNUMBER: 'billingNumber'
};
export const STORAGE = {
  TAB_ID_SESSION: 'TAB_ID_SESSION',
  TAB_ID_LOCAL: 'TAB_ID_LOCAL'
};
export const EXTEND_RENTAL_STATE = {
  SET_EXTEND_ELIGIBILITY: 'SET_EXTEND_ELIGIBILITY',
  INITIATE_EXTEND_RENTAL: 'INITIATE_EXTEND_RENTAL',
  COMMIT_EXTEND_RENTAL: 'COMMIT_EXTEND_RENTAL',
  CLEAR_EXTEND_RENTAL: 'CLEAR_EXTEND_RENTAL'
};

export const EMERALD_CHECKOUT_STATE = {
  INITIATE_EMERALD_CHECKOUT: 'INITIATE_EMERALD_CHECKOUT',
  UPDATE_EMERALD_CHECKOUT: 'UPDATE_EMERALD_CHECKOUT',
  COMMIT_EMERALD_CHECKOUT: 'COMMIT_EMERALD_CHECKOUT',
  CLEAR_EMERALD_CHECKOUT: 'CLEAR_EMERALD_CHECKOUT'
};
export {default as STATE} from './state';
export {SESSION_TIMEOUT} from './sessionTimeout'; 